import { Box, Button, FormControl, Grid, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import S2a001 from '../../../assets/2a001.jpg';
import S2b001 from '../../../assets/2b001.png';
import S2f001 from '../../../assets/2f001.png';
import S2l001 from '../../../assets/2l001.png';

const CreateAutomationTextAndScreen = observer(({ automationStore }) => {
  const getSelectedScreen = () => {
    switch (automationStore.pushScreen) {
      case '2a001':
        return S2a001;
      case '2b001':
        return S2b001;
      case '2f001':
        return S2f001;
      case '2l001':
        return S2l001;
      default:
        return '';
    }
  };
  return (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <Typography>
            <h3>Título</h3>
          </Typography>
          <TextField id='pushTitle' value={automationStore.pushTitle} variant='outlined'
                     onChange={e => automationStore.setPushTitle(e.target.value)}
                     fullWidth />
          <br /><br />
          <Typography fontSize='small'>
            {automationStore.pushTitle.length} caracters
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography>
            <h3>Texto</h3>
          </Typography>
          <TextField id='pushText' value={automationStore.pushText} variant='outlined'
                     onChange={e => automationStore.setPushText(e.target.value)}
                     fullWidth minRows={3} multiline />
          <br /><br />
          <Typography fontSize='small'>
            {automationStore.pushText.length} caracters
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography>
            <h3>Tela Destino</h3>
          </Typography>
          <FormControl fullWidth>
            <Select
              value={automationStore.pushScreen}
              onChange={e => automationStore.setPushScreen(e.target.value)}
            >
              <MenuItem value=''></MenuItem>
              <MenuItem value='2a001'>2a001 - Feed</MenuItem>
              <MenuItem value='2b001'>2b001 - Explorar</MenuItem>
              <MenuItem value='2f001'>2f001 - Perfil do usuário</MenuItem>
              <MenuItem value='2l001'>2l001 - Wishlist</MenuItem>
            </Select>
          </FormControl>
          <br /><br />
          <img src={getSelectedScreen()} width='100%' />
        </Grid>
        <Grid item xs={3}>
          <Typography>
            <h3>&nbsp;</h3>
          </Typography>
          <Button variant='contained' onClick={async (e) => {
            await automationStore.saveTextAndScreen();
          }}>Aplicar ações</Button>
        </Grid>
      </Grid>
    </div>
  );
});

export default CreateAutomationTextAndScreen;
